import React from "react";
import styled from "styled-components";
import moment from "moment";
import { colors } from "@sonder/ui/source/styled/theme";
import {
  TaskUnitBookingInfoCurrentBooking,
  TaskUnitBookingInfoPreviousBooking,
  TaskUnitBookingInfoUpcomingBooking,
} from "core/queries/GetTask";
import {
  GetUserRelatedBookingInquiry,
  GetUserRelatedBookingLeaseInquiry,
} from "core/queries/GetUserRelatedTasks";

const DATE_FORMAT = "ddd. MMM D [at] h:mm a";

const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1.143rem;
`;

const Section = styled.div`
  flex: 1;
`;

const SectionLabel = styled.div`
  color: ${colors.gray6};
  font-size: 0.857rem;
  line-height: 1.143rem;
`;

const SectionText = styled.div`
  margin-top: 0.286rem;
`;

const StyledTurnover = styled.div`
  color: ${colors.gray1};
  line-height: 1.429rem;
`;

const Title = styled.div`
  font-weight: bold;
`;

interface TurnoverProps {
  booking:
    | TaskUnitBookingInfoCurrentBooking
    | TaskUnitBookingInfoPreviousBooking
    | TaskUnitBookingInfoUpcomingBooking
    | GetUserRelatedBookingInquiry
    | GetUserRelatedBookingLeaseInquiry;
  title: string;
}

const getTurnoverPrefix = (turnoverTime: any) => {
  return moment(turnoverTime).isBefore(moment.now()) ? `Checked` : `Checking`;
};

export const Turnover = ({ booking, title }: TurnoverProps) => {
  const { checkInTime, checkOutTime } = booking;

  return (
    <StyledTurnover>
      <Title>{title}</Title>
      <Row>
        <Section>
          <SectionLabel>{`${getTurnoverPrefix(checkInTime)} in`}</SectionLabel>
          <SectionText>{moment(checkInTime).format(DATE_FORMAT)}</SectionText>
        </Section>
        <Section>
          <SectionLabel>{`${getTurnoverPrefix(
            checkOutTime,
          )} out`}</SectionLabel>
          <SectionText>{moment(checkOutTime).format(DATE_FORMAT)}</SectionText>
        </Section>
      </Row>
    </StyledTurnover>
  );
};
